/* ZilZal cart rules guard v8 (by Claude).
   1) MIN ORDER: rewrites any cart request that would drop a guarded item to a
      quantity between 1 and (min-1) up to the minimum BEFORE it reaches Shopify.
      Quantity 0 (remove) is always allowed through, so the trash button works.
   2) BOGO auto-add: for buy-1-get-1-free products, the add-to-cart quantity is
      doubled at the network layer, so the customer adds 1 and the cart holds 2;
      the automatic Buy-1-Get-1 discount then makes the 2nd free.
   3) Exposes window.__zzMinForKey(lineKey) for the floating-cart speed script.
   Add a future min-order product: add its variant id to MINV and product id to MINP.
   Add a future BOGO product: add its variant id to BOGO (and keep the discount + tag in sync). */
(function(){
  var MINV = { '52569134858552': 20, '52569137021240': 20 };
  var MINP = { '10751639945528': 20, '10751640076600': 20 };
  var BOGO = { '52569124536632': true, '52569126732088': true, '52574710726968': true, '52574757617976': true };
  var lines = [];

  function rebuild(items){
    lines = (items || []).map(function(it){
      return { key: String(it.key), vid: String(it.variant_id != null ? it.variant_id : it.id), pid: String(it.product_id) };
    });
  }
  function refresh(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){ rebuild(c.items); })
      .catch(function(){});
  }
  function minByKeyOrVid(idStr){
    for (var i = 0; i < lines.length; i++){
      if (lines[i].key === idStr){ return MINP[lines[i].pid] || MINV[lines[i].vid] || 0; }
    }
    return MINV[idStr] || 0;
  }
  function minByLine(n){
    var it = lines[n - 1];
    return it ? (MINP[it.pid] || MINV[it.vid] || 0) : 0;
  }
  window.__zzMinForKey = function(key){ return minByKeyOrVid(String(key)); };

  /* Only clamp quantities in the range 1..(min-1). 0 means remove -> always allow. */
  function bump(q, min){ return (min && q > 0 && q < min) ? min : q; }
  function addQty(id, q){
    var n = bump(q, MINV[id] || 0);
    if (BOGO[id] && n > 0){ n = n * 2; }
    return n;
  }

  function clamp(kind, d){
    if (kind === 'add'){
      if (d.items && d.items.length){
        d.items.forEach(function(it){
          it.quantity = addQty(String(it.id), Number(it.quantity || 1));
        });
      } else if (d.id != null){
        d.quantity = addQty(String(d.id), Number(d.quantity || 1));
      }
    } else if (kind === 'change'){
      var min = 0;
      if (d.line != null && d.line !== ''){ min = minByLine(parseInt(d.line, 10)); }
      else if (d.id != null){ min = minByKeyOrVid(String(d.id)); }
      if (min && d.quantity != null){ d.quantity = bump(Number(d.quantity), min); }
    } else if (kind === 'update'){
      if (d.updates){
        if (d.updates.length != null && typeof d.updates !== 'string'){
          for (var i = 0; i < d.updates.length; i++){
            d.updates[i] = bump(Number(d.updates[i]), minByLine(i + 1));
          }
        } else {
          Object.keys(d.updates).forEach(function(k){
            d.updates[k] = bump(Number(d.updates[k]), minByKeyOrVid(String(k)));
          });
        }
      }
    }
    return d;
  }

  function kindOf(url){
    if (url.indexOf('/cart/add') !== -1) return 'add';
    if (url.indexOf('/cart/change') !== -1) return 'change';
    if (url.indexOf('/cart/update') !== -1) return 'update';
    return null;
  }

  var origFetch = window.fetch;
  window.fetch = function(input, init){
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var kind = kindOf(url);
    try {
      if (kind && init && init.body != null){
        var b = init.body;
        if (typeof b === 'string'){
          var d = null;
          try { d = JSON.parse(b); } catch (e) { d = null; }
          if (d){ init = Object.assign({}, init, { body: JSON.stringify(clamp(kind, d)) }); }
          else if (b.indexOf('=') !== -1){
            var p = new URLSearchParams(b); var o = {}; p.forEach(function(v,k){ o[k] = v; });
            clamp(kind, o);
            var np = new URLSearchParams(); Object.keys(o).forEach(function(k){ np.append(k, o[k]); });
            init = Object.assign({}, init, { body: np.toString() });
          }
        } else if (b instanceof URLSearchParams){
          var o2 = {}; b.forEach(function(v,k){ o2[k] = v; });
          clamp(kind, o2);
          var u2 = new URLSearchParams(); Object.keys(o2).forEach(function(k){ u2.append(k, o2[k]); });
          init = Object.assign({}, init, { body: u2 });
        } else if (typeof FormData !== 'undefined' && b instanceof FormData){
          var o3 = {}; b.forEach(function(v,k){ o3[k] = v; });
          clamp(kind, o3);
          var f3 = new FormData(); Object.keys(o3).forEach(function(k){ f3.append(k, o3[k]); });
          init = Object.assign({}, init, { body: f3 });
        }
      }
    } catch (e) {}
    var ret = origFetch.apply(this, [input, init]);
    if (kind){ ret.then(function(){ setTimeout(refresh, 60); }).catch(function(){}); }
    return ret;
  };

  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', refresh); }
  else { refresh(); }
  window.addEventListener('pageshow', function(){ setTimeout(refresh, 150); });
  document.addEventListener('click', function(e){
    var t = e.target;
    if (t && t.closest && t.closest('#zzfc')){ setTimeout(refresh, 30); }
  }, true);
  ['bxc:cart-updated', 'cart:updated', 'cart:refresh'].forEach(function(ev){
    document.addEventListener(ev, function(){ setTimeout(refresh, 150); });
  });
})();
